module.exports = __webpack_public_path__ + "static/img/应用场景2-行驶视频监控.8e4ba72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-2/应用场景2-行驶视频监控.png
// module id = /0Pd
// module chunks = 0